import { ElementRendererProps } from "./paragraph";

export const BlockQuote = ({
  attributes,
  children,
}: ElementRendererProps<"blockquote">) => (
  <blockquote
    className="border-l-4 border-neutral-400 pl-4 my-1"
    {...attributes}
  >
    {children}
  </blockquote>
);
